<template>
  <v-row class="pb-8" v-scroll="onScroll">
    <!-- header -->
    <mini-header :breadcrumbs="breadcrumbs" :hiddenTab="true" :dense="true" :scroll="scroll">
      <template v-slot:main>
        <v-spacer />
        <v-btn class="mr-2" color="blue-500" @click="updatedView" outlined>
          <v-img contain :src="require(`@/assets/icon-update${$vuetify.theme.dark ? '-dark' : ''}.svg`)" />
        </v-btn>
        <v-btn class="mr-2" color="blue-500" :to="{ name: 'StoreSales', params: { ...$route.params }}" outlined>
          <v-icon left>mdi-store</v-icon>
          Métricas de tiendas
        </v-btn>
        <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ml-2" color="blue-500" v-bind="attrs" v-on="on">
              <v-icon left>mdi-calendar-blank </v-icon>{{filter[selected.q] ?? 'Fecha'}}<v-icon size="18" right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list class="pa-0">
            <v-list-item class="px-3" @click="selected.q = 'this_day'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Hoy</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'last_day'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Ayer</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'this_week'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Esta semana</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'last_week'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Semana pasada</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'this_month'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Este mes</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'last_month'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Mes pasado</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </mini-header>
    <!-- end header -->
    <template v-if="loading">
      <v-col cols="12" class="pa-0">
        <v-row class="mt-5 px-1" >
          <v-col cols="4" class="pa-0" v-for="item in 3" :key="item">
            <v-skeleton-loader class="mt-n3 pa-2"
            style="border-radius: 10px !important;" transition="fade-transition" type="list-item-two-line"/>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-10 pa-0">
        <v-row class="px-1">
          <v-col cols="6" class="pa-0" v-for="item in 2" :key="item">
            <v-skeleton-loader class="mt-n3 pa-2"
            style="border-radius: 10px !important;" transition="fade-transition" type="image"/>
          </v-col>
        </v-row>
      </v-col>
    </template>

    <template v-else>
      <v-col cols="12" v-if="!hasData">
        <empty-state class="mt-10" type="metrics-branch" id="metrics" :height="320" title="¿Quieres ver el monitor?" description="Filtra para obtener registros" :hiddenDescription="true" :isFree="true" />
      </v-col>
      <template v-else>
        <v-col cols="12" class="pa-0">
          <v-card class="mt-0 px-5 pt-5 pb-7" flat>
            <span class="d-block text-subtitle-2 grey-700--text font-weight-bold mb-5 ml-n1">Total de ventas</span>
            <v-row>
              <v-col cols="3" class="py-0 px-2">
                <span class="d-block">
                  <span class="font-weight-bold text-h4 grey-700--text">
                    {{$store?.state?.auth?.account?.country === 'PE' ? 'S./' : currencyCL}} {{ formatNumber2(summary.net, this.$store.state.auth.account.currency !== 'CLP') }}
                  </span>
                  <span class="text-subtitle-1 grey-500--text ml-1 ">Neto</span>
                </span>
              </v-col>
              <v-divider vertical />
              <v-spacer />
              <v-col cols="3" class="py-0 px-2">
                <span class="d-block">
                  <span class="font-weight-bold text-h4 grey-700--text">
                    {{$store?.state?.auth?.account?.country === 'PE' ? 'S./' : currencyCL}} {{ formatNumber2(summary.igv, this.$store.state.auth.account.currency !== 'CLP') }}
                  </span>
                  <span class="text-subtitle-1 grey-500--text ml-1">{{$store?.state?.auth?.account?.country !== 'PE' ? 'IVA' : 'IGV'}}</span>
                </span>
              </v-col>
              <v-divider vertical />
              <v-spacer />
              <v-col cols="3" class="py-0 px-2">
                <span class="d-block">
                  <span class="font-weight-bold text-h4 grey-700--text">
                    {{$store?.state?.auth?.account?.country === 'PE' ? 'S./' : currencyCL}} {{ formatNumber2(summary.total, this.$store.state.auth.account.currency !== 'CLP') }}
                  </span>
                  <span class="text-subtitle-1 grey-500--text ml-1 ">Total </span>
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" class="pa-0 mt-1" >
          <v-row class="px-1 mt-4">
            <v-col cols="6" class="py-0 px-2">
              <v-card class="pa-4 rounded-md" flat>
                <span class="text-subtitle-2 grey-700--text font-weight-bold">Q Tickets</span>
                <span class="d-block mt-2 font-weight-bold text-h4 grey-700--text">
                  {{ formatNumber2(summary.count, false) }}
                </span>
              </v-card>
            </v-col>
            <v-col cols="6" class="py-0 px-2">
              <v-card class="pa-4 rounded-md" flat>
                <span class="text-subtitle-2 grey-700--text font-weight-bold">Ticket promedio</span>
                <span class="d-block mt-2 font-weight-bold text-h4 grey-700--text">
                  {{$store?.state?.auth?.account?.country === 'PE' ? 'S./' : currencyCL}} {{ formatNumber2(summary.average_ticket, this.$store.state.auth.account.currency !== 'CLP') }}
                </span>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mt-8 px-1">
            <v-col cols="12" class="py-0 px-2">
              <v-card flat class="d-flex flex-column">
                <v-card-title class="pt-3 px-0">
                  <v-toolbar color="transparent" flat height="46">
                    <v-toolbar-title class="px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold">Ventas</v-toolbar-title>
                    <v-spacer />
                    <div class="d-flex pr-5">
                      <v-sheet class="d-flex mr-4 ml-1 rounded-sm" width="7" height="14" color="blue-500" />
                      <span class="body-2 grey-500--text ml-n2">Ventas</span>
                    </div>
                  </v-toolbar>
                </v-card-title>
                <v-card-text class="pb-4 flex-grow-1">
                  <chart-line :chart-data="salesChart" :show-legend="false" :month-label="salesMonth" :show-point="false" :numberRounded="this.$store.state.auth.account.currency !== 'CLP'"
                  :height="chartHeight" :key="`line-${chartHeight}`" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-5 py-0 px-2">
              <v-card flat class="d-flex flex-column">
                <v-card-title class="pt-3 px-0">
                  <v-toolbar color="transparent" flat height="46">
                    <v-toolbar-title class="px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold">Q-Promedio por ticket</v-toolbar-title>
                    <v-spacer />
                    <div class="d-flex pr-5">
                      <div class="d-flex">
                        <v-sheet class="d-flex mr-4 ml-1 rounded-sm" width="7" height="14" color="blue-100" />
                        <span class="body-2 grey-500--text ml-n2">Q de tickets</span>
                      </div>
                      <div class="d-flex ml-5">
                        <v-sheet class="d-flex mr-4 ml-1 rounded-sm" width="7" height="14" color="blue-500" />
                        <span class="body-2 grey-500--text ml-n2">Ticket promedio</span>
                      </div>
                    </div>
                  </v-toolbar>
                </v-card-title>
                <v-card-text class="pb-4 flex-grow-1">
                  <chart-bar-line :chart-data="avgTicketChart" :x-axis-label="salesMonth" :show-legend="false" x-axis-type="date" :height="chartHeight" :key="`bar-line-${chartHeight}`" />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

        </v-col>
      </template>
    </template>
  </v-row>
</template>
<script>
import MiniHeader from '@/components/commons/MiniHeader'
import ListViewMixin from '@/mixins/ListViewMixin'
import ChartBarLine from '@/components/charts/ChartBarLine'
import ChartLine from '@/components/charts/ChartLine'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import EmptyState from '@/components/commons/VEmptyState'
import { mapState } from 'vuex'

export default {
  components: {
    MiniHeader,
    ChartBarLine,
    ChartLine,
    EmptyState
  },
  mixins: [
    ListViewMixin,
    GenericViewMixin
  ],
  data: () => ({
    selected: {
      q: ''
    },
    filter: {
      this_day: 'Hoy',
      last_day: 'Ayer',
      this_week: 'Esta semana',
      last_week: 'Semana pasada',
      this_month: 'Este mes',
      last_month: 'Mes pasado'
    },
    summary: {},
    salesChart: {
      labels: [],
      datasets: [
        {
          label: 'Ventas',
          borderColor: '#0352cc',
          backgroundColor: 'rgba(36, 102, 203, 0.1)',
          data: [],
          type: 'line',
          fill: true,
          lineTension: 0.4
        }
      ]
    },
    avgTicketChart: {
      labels: [],
      datasets: [
        {
          label: 'Q de ticket',
          backgroundColor: '#b1c9ef',
          data: [],
          yAxisID: 'left-y-axis',
          type: 'bar'
        },
        {
          label: 'Promedio de ventas',
          borderColor: '#0352cc',
          backgroundColor: 'rgba(36, 102, 203, 0.1)',
          data: [],
          type: 'line',
          fill: false,
          borderWidth: 2,
          yAxisID: 'right-y-axis',
          lineTension: 0.4
        }
      ]
    },
    salesMonth: '',
    hasData: false,
    scroll: 0,
    loading: false,
    reset: 0,
    windowHeight: 0
  }),
  computed: {
    ...mapState({
      countriesList: state => state.base.countriesList
    }),
    breadcrumbs () {
      return {
        main: 'Métricas',
        children: [
          { text: 'Ventas de la organización' }
        ]
      }
    },
    chartHeight () {
      const calculatedHeight = (this.windowHeight - 600) / 2
      return calculatedHeight > 100 ? calculatedHeight : 120
    },
    currencyCL () {
      return this.$store.state.auth.account.currency === 'CLP' ? 'CLP' : '$'
    }
  },
  watch: {
    '$route' () {
      this.updatedView()
    },
    selected: {
      handler (val) {
        if (val.q) {
          this.$router.replace({ query: { q: val.q } }).catch(() => {})
        }
      },
      deep: true
    }
  },
  created () {
    if (this.$route.query.q) this.selected.q = this.$route.query.q
    else this.selected.q = 'this_day'
    this.updatedView()
    window.addEventListener('resize', this.onResize)
  },
  mounted () {
    this.$nextTick(() => {
      this.onResize()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize () {
      this.windowHeight = window.innerHeight
    },
    onScroll (e) {
      this.offsetTop = e.target?.scrollingElement?.scrollTop ?? 0
    },
    updatedView () {
      this.getData()
    },
    getData () {
      this.loading = true
      this.hasData = false
      this.salesMonth = ''
      this.summary = {}
      this.salesChart.labels = []
      this.salesChart.datasets[0].data = []
      this.avgTicketChart.labels = []
      this.avgTicketChart.datasets[0].data = []
      this.avgTicketChart.datasets[1].data = []

      const period = this.selected.q || 'this_month'
      let query = JSON.parse(JSON.stringify(this.$route.query))
      delete query.branch
      delete query.q

      this.$store.dispatch('accounts/GET', {
        resource: `metrics/account/amounts/${period}`,
        query: {
          ...query,
          ...(this.$store.state.auth.account.currency && { currency: this.$store.state.auth.account.currency }),
          ...(this.$store.state.auth.account.time_zone && { timezone: this.$store.state.auth.account.time_zone })
        }
      })
      .then((response) => {
        const data = response.data

        if (data.daily && data.daily.length > 0) {
          this.hasData = true

          // Set month name based on period type
          let monthName = ''
          if (period === 'this_month' || period === 'last_month') {
            // For month periods, use current month or last month respectively
            const targetDate = period === 'this_month' ? new Date() : new Date(new Date().setMonth(new Date().getMonth() - 1))
            monthName = targetDate.toLocaleDateString('es-ES', { month: 'long' })
          } else {
            // For other periods, use the first date from data
            const firstDate = new Date(data.daily[0].date)
            monthName = firstDate.toLocaleDateString('es-ES', { month: 'long' })
          }
          this.salesMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1)

          console.log('period:', period, 'monthName:', monthName, 'salesMonth:', this.salesMonth)

          // Process daily data for charts
          const dates = data.daily.map(item => item.date)
          const salesByDay = data.daily.map(item => parseFloat(item.total))
          const countByDay = data.daily.map(item => item.count)
          const avgAmountByDay = data.daily.map(item => parseFloat(item.avg))

          // Update Ventas Chart
          this.salesChart.labels = dates
          this.salesChart.datasets[0].data = salesByDay

          // Update Q-Promedio por ticket Chart
          this.avgTicketChart.labels = dates
          this.avgTicketChart.datasets[0].data = countByDay
          this.avgTicketChart.datasets[1].data = avgAmountByDay
        } else {
          this.hasData = false
        }

        // Process summary data
        this.summary = {
          total: parseFloat(data.total),
          net: parseFloat(data.net),
          igv: parseFloat(data.igv),
          count: data.count,
          average_ticket: data.count > 0 ? parseFloat(data.total) / data.count : 0
        }
      })
      .catch(() => {
        this.hasData = false
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss">
.v-skeleton-loader .v-skeleton-loader__list-item, .v-skeleton-loader .v-skeleton-loader__list-item-avatar, .v-skeleton-loader .v-skeleton-loader__list-item-text, .v-skeleton-loader .v-skeleton-loader__list-item-two-line, .v-skeleton-loader .v-skeleton-loader__list-item-avatar-two-line, .v-skeleton-loader .v-skeleton-loader__list-item-three-line, .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line {
    border-radius: 10px;
}
</style>
